"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var history_1 = require("./history");
var getSearchParams_1 = require("./getSearchParams");
var RuntimeModule = /** @class */ (function () {
    function RuntimeModule(appConfig, buildConfig, context) {
        var _this = this;
        this.setRenderRouter = function (renderRouter) {
            _this.renderRouter = renderRouter;
        };
        this.wrapperRouterRender = function (wrapper) {
            // pass origin router render for custom requirement
            _this.renderRouter = wrapper(_this.renderRouter);
        };
        this.addProvider = function (Provider) {
            _this.AppProvider.push(Provider);
        };
        this.addDOMRender = function (render) {
            _this.modifyDOMRender = render;
        };
        this.modifyRoutes = function (modifyFn) {
            _this.modifyRoutesRegistration.push(modifyFn);
        };
        this.modifyRoutesComponent = function (modify) {
            _this.routesComponent = modify(_this.routesComponent);
        };
        this.wrapperRouteComponent = function (wrapperRoute) {
            _this.wrapperRouteRegistration.push(wrapperRoute);
        };
        this.wrapperRoutes = function (routes) {
            return routes.map(function (item) {
                if (item.children) {
                    item.children = _this.wrapperRoutes(item.children);
                }
                else if (item.component) {
                    item.routeWrappers = _this.wrapperRouteRegistration;
                }
                return item;
            });
        };
        this.getAppRouter = function () {
            var routes = _this.wrapperRoutes(_this.modifyRoutesRegistration.reduce(function (acc, curr) {
                return curr(acc);
            }, []));
            return _this.renderRouter(routes, _this.routesComponent);
        };
        this.renderRouter = function () { return function () { return context.createElement('div', null, 'No route'); }; };
        this.routesComponent = false;
        this.AppProvider = [];
        this.appConfig = appConfig;
        this.buildConfig = buildConfig;
        this.context = context;
        this.modifyDOMRender = null;
        this.modifyRoutesRegistration = [];
        this.wrapperRouteRegistration = [];
    }
    RuntimeModule.prototype.loadModule = function (module) {
        var runtimeAPI = {
            setRenderRouter: this.setRenderRouter,
            addProvider: this.addProvider,
            addDOMRender: this.addDOMRender,
            modifyRoutes: this.modifyRoutes,
            wrapperRouteComponent: this.wrapperRouteComponent,
            wrapperRouterRender: this.wrapperRouterRender,
            modifyRoutesComponent: this.modifyRoutesComponent,
            createHistory: history_1.createHistory,
            getSearchParams: getSearchParams_1.default,
        };
        if (module)
            (module.default || module)(__assign(__assign({}, runtimeAPI), { appConfig: this.appConfig, buildConfig: this.buildConfig, context: this.context }));
    };
    RuntimeModule.prototype.composeAppProvider = function () {
        var _this = this;
        if (!this.AppProvider.length)
            return null;
        return this.AppProvider.reduce(function (ProviderComponent, CurrentProvider) {
            return function (_a) {
                var children = _a.children, rest = __rest(_a, ["children"]);
                var element = CurrentProvider
                    ? _this.context.createElement(CurrentProvider, __assign({}, rest), children)
                    : _this.context.createElement(children);
                return _this.context.createElement(ProviderComponent, __assign({}, rest), element);
            };
        });
    };
    return RuntimeModule;
}());
exports.default = RuntimeModule;
